import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Disclaimer = () => {
  return (
    <div className="pb-16 bg-brand-bone min-h-screen" data-testid="disclaimer-page">
      {/* Hero */}
      <section className="bg-brand-black/[0.03] py-12 md:py-20 border-b border-brand-cobalt/10">
        <div className="max-w-4xl mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-sm text-brand-cobalt hover:text-brand-cobalt/80 mb-6"
          >
            <ArrowLeft size={16} />
            Volver al inicio
          </Link>
          <h1 className="font-display text-3xl md:text-5xl tracking-tight mb-4 text-brand-black">
            Disclaimer Legal
          </h1>
          <p className="text-brand-black/60 text-lg">
            Aviso legal sobre marcas y propiedad intelectual
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <div className="brand-card hybrid-glow p-6 md:p-8 rounded-lg">
              <p className="text-brand-black/80 leading-relaxed mb-6">
                <strong className="text-brand-cobalt">Alphatica</strong> es una marca independiente especializada en fragancias de inspiración.
              </p>

              <p className="text-brand-black/80 leading-relaxed mb-6">
                Las referencias a perfumes comerciales o de nicho se utilizan exclusivamente con fines
                descriptivos para ayudar a los clientes a identificar perfiles olfativos similares.
              </p>

              <p className="text-brand-black/80 leading-relaxed mb-6">
                Alphatica <strong className="text-brand-black">no tiene ninguna afiliación, asociación, autorización o relación comercial</strong> con las
                marcas mencionadas.
              </p>

              <p className="text-brand-black/80 leading-relaxed">
                Todas las marcas registradas, nombres comerciales y derechos de propiedad intelectual
                pertenecen a sus respectivos propietarios.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Disclaimer;
